__turbopack_context__.v({
  "participantName": "GEYSFG_participantName",
  "price": "GEYSFG_price",
  "roomName": "GEYSFG_roomName",
});
